export function uniqueArrayElements(array: number[]): number[] {
    const copy = array.slice();
    // Removes duplicates (requires sorting)
    return copy.sort(function(ftid1, ftid2) {
        return ftid1 - ftid2;
    }).reduce(function(accumulator, ftid) {
        if (accumulator.slice(-1)[0] !== ftid) {
            accumulator.push(ftid);
        }
        return accumulator;
    }, []);
}

/**
 * Create a copy of an array, with the given item replaced.
 *
 * @param array Original array
 * @param index Index to replace
 * @param item Item to place at index
 * @return New array with replaced item
 */
export function replaceItem<T>(array: Array<T>, index: number, item: T): Array<T> {
    if (index >= array.length || index < 0) {
        throw new RangeError("Index " + index + " out of bounds");
    }

    return [...array.slice(0, index),
            item,
            ...array.slice(index + 1)]
}

// https://stackoverflow.com/a/37826698
export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
    return array.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
    }, []);
}